import * as React from 'react';
import { Formik } from 'formik';
// import LoadingButton from '@material-ui/lab/LoadingButton';
import {
	BForm,
	BPassword,
	BSubmit,
	BTextField,
} from 'mui-bueno';
import {
	CreateUserRequest, LoadingProps,
} from '../../@types';
import { useHistory } from 'react-router-dom';
import { useFormStyles, useOtherStyles } from '../../App';
import About from '../About/About';
import theme from '../../theme';
import Box from '@material-ui/core/Box';
import {
	Divider,
	Link,
	Typography,
} from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import { createUser } from '../../axios/user';

import Grid from '@material-ui/core/Grid';
import { useState } from 'react';
import ForcefulDialog from '../../common/Dialog/ForcefulDialog';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles({
	paper: {
		height: '140',
		width: '100',
	},
	control: {
		padding: theme.spacing(2),
	},
	gridWrapper: {
		flexGrow: 1,
	},
	root: {
		maxWidth: '100%',
		margin: '0 auto',
	},
	submitButton: {
		backgroundColor: theme.palette.secondary.main,
		margin: '15px auto 20px',
	},
});

const initialValues: CreateUserRequest = {
	firstName: '',
	lastName: '',
	email: '',
	password: ''
	// qToken: ''
};

export const SignUp = (props: LoadingProps) => {
	const globalClasses = useOtherStyles();
	const formClasses = useFormStyles();
	const history = useHistory();
	const classes = useStyles();
	const [success, setSuccess] = useState(false);
	// const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleLoginReroute = () => {
		history.push('/Login');
	};

	const handleSubmit = async (newUser: CreateUserRequest) => {
		// setLoading(true);
		props.setLoading(true)
		await createUser(newUser)
			.then((res) => {
				setSuccess(true);
				// setTitle('Success!');
				setDescription('Login to get started.');
				props.setLoading(false)
				handleClickOpen();
			})
			.catch((err: any) => {
				alert(err.response.data.message);
				props.setLoading(false)
				console.log('ERROR: ', err.response.data.message);
			});

		// setLoading(false);
	};

	return (
		<>
			<div className={classes.root}>
				<About />
				<Box 
				boxShadow={5}
				bgcolor={theme.palette.primary.light}
				className={formClasses.formWrapper}>
					<Typography variant='h4' className={formClasses.formTitle}>
						Create an Account
					</Typography>
					<Typography
						variant='subtitle2'
						className={formClasses.formSubtitle}
					>
						Sign up to start fighting disinformation!
					</Typography>
					<Divider />
					<Formik
						initialValues={initialValues}
						onSubmit={handleSubmit}
						validateOnBlur={false}
						validateOnChange={false}
					>
						<BForm>
							<Grid
								container
								className={classes.gridWrapper}
								spacing={0}
							>
								<Grid item xs={6}>
									<BTextField
										required
										full
										name='firstName'
										placeholder='First Name'
									/>
								</Grid>
								<Grid item xs={6}>
									<BTextField
										required
										full
										name='lastName'
										placeholder='Last Name'
									/>
								</Grid>
							</Grid>
							<BTextField
								required
								full
								name='email'
								placeholder='Email'
							/>
							{/* <BTextField
										required
										full
										name='username'
										placeholder='Username'
									/> */}
							<BPassword
								required
								full
								name='password'
								placeholder='Password'
							/>
							{/* <BTextField required full name='qToken' label='Qurosinty Token' /> */}
							{/* <Typography variant='caption' className={formClasses.formHint}>
								(Go to <Link color='textSecondary' target="blank" href="https://quriosinty.herokuapp.com/profile/"><u>Your Quriosity Profile</u></Link> to see your token)
							</Typography> */}
							{/* {loading ? (
								 <LoadingButton
								 color="secondary"
								 onClick={handleClick}
								 pending={pending}
								 pendingPosition="start"
								 startIcon={<SaveIcon />}
								 variant="contained"
							   >
								 Save
							   </LoadingButton>
							) : (
								<> */}
							<BSubmit
								className={classes.submitButton}
								name='submit'
							>
								Create Account
							</BSubmit>
							{/* </>
							)} */}
						</BForm>
					</Formik>
					<Box padding='10px 0px 10px 40px'>
						<Typography className={formClasses.formSwitchMessage}>
							Already have an account?
						</Typography>
						<Link
							onClick={handleLoginReroute}
							className={formClasses.formSwitchLink}
						>
							<u>Login</u>
						</Link>
					</Box>
				</Box>
				<ForcefulDialog
					title='Success!'
					description='Sign in to get started'
					open={open}
					setOpen={setOpen}
					disableBgClick={success}
					onSubmit={handleLoginReroute}
					submitMessage={"Login"}
				/>
			</div>
		</>
	);
};

export default IsLoadingHOC(SignUp);
